// extracted by mini-css-extract-plugin
export var circle = "_4g-2";
export var icon = "_4g-a";
export var iconHighlight = "_4g-0";
export var lg = "_4g-8";
export var md = "_4g-7";
export var outline = "_4g-4";
export var sm = "_4g-6";
export var square = "_4g-1";
export var xl = "_4g-9";
export var xs = "_4g-5";
export var xxs = "_4g-3";